import React from 'react';
import { Typography, ClickAwayListener } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import {
  JupiterTheme,
  Popover,
  MockHook,
} from '@jupiterone/jupiter-web-toolkit';
import useNewNotificationsPopoverLogic, {
  NewNotificationsPopoverComponentProps,
} from 'navbar/src/notifications/NewNotificationsPopover/useNewNotificationsPopoverLogic';
import NotificationCard from 'navbar/src/notifications/NotificationsDrawer/NotificationCard';
import NotificationIcon from 'navbar/src/notifications/NotificationsDrawer/NotificationCard/NotificationIcon';

const useStyles = makeStyles<JupiterTheme>((theme) =>
  createStyles({
    popover: {
      right: '-10px',
    },
    single: {
      width: '430px',
      '&:hover': {
        backgroundColor: 'inherit',
      },
    },
    multiple: {
      cursor: 'pointer',
      display: 'flex',
      padding: theme.spacing(1.5),
    },
    message: {
      marginLeft: theme.spacing(1),
    },
  })
);

export const NewNotificationsPopoverComponent = ({
  children,
  newNotifications,
  isNewNotificationsPopoverOpen,
  handleNewNotificationsClick,
  handleDismissNewNotifications,
}: NewNotificationsPopoverComponentProps) => {
  const classes = useStyles();

  return (
    <Popover
      className={classes.popover}
      open={isNewNotificationsPopoverOpen}
      content={
        <ClickAwayListener onClickAway={handleDismissNewNotifications}>
          <div>
            {newNotifications.length === 1 && newNotifications[0] ? (
              <NotificationCard
                className={classes.single}
                onClick={handleNewNotificationsClick}
                {...newNotifications[0]}
              />
            ) : (
              <div
                className={classes.multiple}
                onClick={handleNewNotificationsClick}
              >
                <NotificationIcon />
                <Typography className={classes.message}>
                  {newNotifications.length} New Notifications
                </Typography>
              </div>
            )}
          </div>
        </ClickAwayListener>
      }
    >
      {children}
    </Popover>
  );
};

export default MockHook.withHookHoc(
  NewNotificationsPopoverComponent,
  useNewNotificationsPopoverLogic
);
